import { takeLatest, put, call } from "redux-saga/effects";
import authActions from "../actions/authActions";
import HttpService from "../../services/httpServices/httpServices";

const checkUserLoginWorker = function* () {
  try {
    const resultInitUser = yield call(() => {
      const url = process.env.REACT_APP_DOMAIN_API + "/v1/auth/init";
      const token = localStorage.getItem("token");

      const headersRequest = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      return HttpService.getRequest(url, headersRequest);
    });

    const resultGetFinanceData = yield call(() => {
      const url = process.env.REACT_APP_DOMAIN_API + "/v1/publisher/finance";
      const token = localStorage.getItem("token");

      const headersRequest = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      return HttpService.getRequest(url, headersRequest);
    });

    const payload = {
      ...resultInitUser.data.data,
      ...resultGetFinanceData.data.data,
    };

    yield put({
      type: authActions.CHECK_USER_LOGIN_SUCCESS,
      payload: payload,
    });
  } catch (error) {
    yield put({
      type: authActions.CHECK_USER_LOGIN_FAILED,
      payload: null,
    });
  }
};

export const checkUserLoginWatcher = function* () {
  yield takeLatest(authActions.CHECK_USER_LOGIN, checkUserLoginWorker);
};
